<template>
  <el-dialog
    :title="title"
    :visible.sync="dialogAddClient"
    :before-close="doClose"
    width="60%"
    top="5vh"
  >
    <el-form :ref="formRef" :rules="rules" :model="gatherUnitform" label-width="200px">
      <el-form-item prop="inputUnit" :label="$t('gatherUnit.inputUnit')">
        <el-input v-model="gatherUnitform.inputUnit" style="width: 200px"></el-input>
      </el-form-item>
      <el-form-item prop="outputUnit" :label="$t('gatherUnit.outputUnit')">
        <el-input v-model="gatherUnitform.outputUnit" style="width: 200px"></el-input>
      </el-form-item>
      <el-form-item prop="offset" :label="$t('gatherUnit.offset')">
        <el-input type='number' v-model="gatherUnitform.offset" style="width: 200px"></el-input>
      </el-form-item>
      <el-form-item prop="scale" :label="$t('gatherUnit.scale')">
        <el-input type='number' v-model="gatherUnitform.scale" style="width: 200px"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button v-if="subButtonAuth" type="success" @click="onSubBtn(formRef)">{{$t("button.confirm")}}</el-button>
        <el-button @click="doClose">{{$t("button.cancel")}}</el-button>
      </el-form-item>
    </el-form>
  </el-dialog>
</template>

<script>
export default {
  name: "index",
  props: {
    subButtonAuth: false,
      formRef:"",
      title:"",
      dialogAddClient: false,
      gatherUnitform:{
        inputUnit:"",
        outputUnit:"",
      },
      type:"",
  },
  data(){
    return{
      rules:{
        inputUnit:[{required:true, message: this.$t('tips.needed'), trigger: 'blur'}],
        outputUnit:[{required:true, message: this.$t('tips.needed'), trigger: 'blur'}],
        offset:[{required:true, message: this.$t('tips.mustNumebr'), trigger: ['blur','change']}],
        scale:[{required:true, message: this.$t('tips.mustNumebr'), trigger: ['blur','change']}],
      }
    }
  },
  methods: {
    onSubBtn(value) {
      this.$refs[value].validate((valid) => {
        if (valid) {
          this.$emit("onSubBtn", true);
        } else {
          return false;
        }
      });
    },
    doClose() {
      this.$emit("dialogVisibleEvent", false);
      this.$refs[this.formRef].resetFields();
    },
  },
};
</script>

<style>
</style>
